<template>

    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>

        <p class="text-headline-small">Elementi</p>
        <v-number-input label="Numero elementi" v-model="properties.elementi" :min="1" :max="30"
            class="mb-2">
        </v-number-input>
    </v-card>


    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>

        <p class="text-headline-small">Freschezza</p>

        <v-switch inset v-model="properties.freschezza" 
        class=""
         hide-details 
        color="primary" :label="properties.freschezza ? 'fresca' : 'non fresca' "></v-switch>

    </v-card>

    <SegmentoCommon v-model="properties" />

</template>

<script setup>

import { ref } from 'vue'
import SegmentoCommon from "@/reports/components/SegmentoCommon"


const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})

</script>
